import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BlogGallery from './components/BlogGallery';
import FeaturedArticles from './components/FeaturedArticles';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import AnimatedHighlights from './components/AnimatedHighlights';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <BlogGallery />
        <FeaturedArticles />
        <AboutSection />
        <ContactSection />
        <AnimatedHighlights />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
